(() => {
  if (window.AcCustomerPrivacy) return;
  let loading;
  const ready = () => {
    if (window.Shopify?.customerPrivacy?.setTrackingConsent) return Promise.resolve(window.Shopify.customerPrivacy);
    if (loading) return loading;
    loading = new Promise((resolve, reject) => {
      const timer = setTimeout(() => reject(new Error('Privacy API timeout')), 10000);
      const finish = (error) => {
        clearTimeout(timer);
        if (error || !window.Shopify?.customerPrivacy) reject(error || new Error('Privacy API unavailable'));
        else resolve(window.Shopify.customerPrivacy);
      };
      if (!window.Shopify?.loadFeatures) { finish(new Error('Privacy loader unavailable')); return; }
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], finish);
    }).catch((error) => { loading = null; throw error; });
    return loading;
  };
  window.AcCustomerPrivacy = {
    ready,
    async read() { return (await ready()).currentVisitorConsent(); },
    async shouldShow() { return (await ready()).shouldShowBanner(); },
    async save(consent) {
      const api = await ready();
      // This single adapter owns consent. Data-sale/GPC settings are independent.
      const choices = Object.fromEntries(['preferences', 'analytics', 'marketing'].map(key => [key, consent[key] === true]));
      await new Promise((resolve, reject) => {
        const timer = setTimeout(() => reject(new Error('Privacy save timeout')), 10000);
        api.setTrackingConsent(choices, (result) => {
          clearTimeout(timer);
          if (result?.error) { reject(new Error('Privacy save failed')); return; }
          const saved = api.currentVisitorConsent();
          if (!Object.entries(choices).every(([key, value]) => saved[key] === (value ? 'yes' : 'no'))) {
            reject(new Error('Privacy choice not confirmed')); return;
          }
          resolve();
        });
      });
    },
  };
})();
